import * as ko from "knockout";
import * as Constants from "../common/constants";
import * as Global from "../common/global";
import * as UI from "../common/ui";
import * as AppointmentAddData from "../data/appointmentAddData";
import * as AppointmentData from "../data/appointmentData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";

import * as Data from "../interfaces/data";

interface IViewModel {
    CreatingTask: KnockoutObservable<string>;
}

export class TaskAutoAddController implements IController  {
    // private properties
    private container: JQuery;
    private viewModel: IViewModel;
    constructor() {
        // Assign the status
        this.viewModel = {
            CreatingTask: ko.observable(`Please wait while your ${Constants.LABEL_APPOINTMENT} is being created...`),
        };

    }
    public render(container: JQuery): JQueryPromise<any> {
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.container = container;

        app.templates().render("taskautoadd", "template_taskautoadd", this.container)
        .done(() => {
            ko.applyBindings(this.viewModel, this.container[0]);
            deferred.resolve();
        });
        return deferred.promise();

    }

    public load(params: any[]): JQueryPromise<any> {
        const me: TaskAutoAddController = this;
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const waitContainer: JQuery<HTMLElement> = UI.showWaitIndicator(this.container);
        let templateID: number| null = null;
        if (params != null && params.length > 0) {
           templateID = Number(params[0]);
        }
        const request: AppointmentAddData.ITaskAutoAddRequest = {
             TemplateID: templateID,
        };
        AppointmentAddData.createDefaultAppointment(request)
         .done((response: Data.IResponse<AppointmentData.IAppointment>) => {
             if (response.Success) {
                app.pageManager().gotoTaskPage(response.Payload.ID, true);
                deferred.resolve();
             } else {
                 me.showErrorMessages(response.ErrorMessages);
             }
         })
         .fail(() => {
             deferred.reject();
         })
         .always(() => {
            UI.hideWaitIndicator(me.container, waitContainer);
        });

        return deferred.promise();
    }

    public haveFieldsChanged(): boolean {
        return false;
    }
    public appRouterID(params: any[]): string {
        let routerID: string = "TaskAutoAdd";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    }

    public title(): string {
        return `Create ${Constants.LABEL_APPOINTMENT}`;
    }

    public subTitle(): string {
        return "";
    }

    private showErrorMessages(errMessages: string[]): void {
        const me: TaskAutoAddController = this;
        me.viewModel.CreatingTask(errMessages.join("."));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/taskAutoAdd.ts